import { lazy } from 'react';
import { RoleBasedGuard } from 'src/auth/guard';
import { ROLES } from 'src/constants';

// ----------------------------------------------------------------------

const EmployeeProcessingPage = lazy(() => import('src/pages/employee-processing'));

// ----------------------------------------------------------------------

const guarded = (
  <RoleBasedGuard navigateTo roles={[ROLES.IT_ADMIN]}>
    <EmployeeProcessingPage />
  </RoleBasedGuard>
);

export const employeeProcessingRoutes = [
  {
    path: 'employee-processing',
    element: guarded,
  },
];
